import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";

import { companyShape } from "lib/propTypes";
import { AUTH_ERROR } from "lib/constants";
import { processFormInputs } from "lib/util";
import { ownPropsPriority } from "redux/utils";
import { authWorkforceSignUp } from "redux/auth/actions";

const mapStateToProps = (state) => ({
    error: state.authError.error,
    submitting: state.ws.ui.submitting,
});

class SurveySignUp extends React.PureComponent {
    static propTypes = {
        authWorkforceSignUp: PropTypes.func.isRequired,
        company: companyShape.isRequired,
        error: PropTypes.number,
        submitting: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        error: null,
    };

    state = {
        errors: {},
        loading: false,
    };

    static getDerivedStateFromProps({ error }, { errors }) {
        if (!error) {
            return {};
        }

        const newErrors = { ...errors };
        switch (error) {
            case AUTH_ERROR.INVALID_EMAIL:
            case AUTH_ERROR.INVALID_HANDLE:
                newErrors.email = "Please enter a valid email address";
                break;

            case AUTH_ERROR.LAST_NAME_REQUIRED:
                newErrors.name = "Please enter your full name";
                break;

            default:
                break;
        }

        return { errors: newErrors };
    }

    onSubmit = (event) => {
        event.preventDefault();

        const { data, errors } = processFormInputs(this.form);
        if (data.name && data.name.indexOf(" ") === -1) {
            errors.name = "Please enter your full name";
        }

        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }

        data.company = this.props.company.id;

        this.props.authWorkforceSignUp(data);
    };

    renderError(field) {
        const { errors } = this.state;
        const error = errors[field];
        if (!error) {
            return null;
        }

        return <span className="help-block">{error}</span>;
    }

    renderForm() {
        const { company } = this.props;

        const buttonClass = classNames("btn btn-primary btn-large", {
            loading: this.props.submitting,
        });

        return (
            <div className="signup-form-step" ref={(c) => (this.form = c)}>
                <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                        id="name"
                        name="name"
                        type="text"
                        className="fs-hide"
                        autoComplete="name"
                        autoCorrect="off"
                        required
                    />
                    {this.renderError("name")}
                </div>

                <div className="form-group">
                    <label htmlFor="email">Email address</label>
                    <input
                        id="email"
                        name="email"
                        type="email"
                        placeholder="me@example.com"
                        autoCapitalize="none"
                        inputMode="email"
                        required
                    />
                    {this.renderError("email")}
                </div>

                <div className="form-group">
                    <label htmlFor="tenure">
                        How long have you been working at {company.name}?
                    </label>
                    <select id="tenure" name="tenure">
                        <option value="7">About a week</option>
                        <option value="30">About a month</option>
                        <option value="30-90">1-3 months</option>
                        <option value="90-365">3 months to 1 year</option>
                        <option value="365+">More than 1 year</option>
                    </select>
                </div>

                <button
                    className={buttonClass}
                    disabled={this.state.loading}
                    onClick={this.onSubmit}
                >
                    Next
                </button>
            </div>
        );
    }

    render() {
        const { company } = this.props;

        return (
            <div className="survey-sign-up">
                <header>
                    <h1>How do you feel about {company.name}?</h1>
                    <p>
                        Survey results are anonymous and your honest feedback will help your company
                        know how they can do better!
                    </p>
                </header>

                {this.renderForm()}

                <footer>
                    <p>
                        By clicking &ldquo;Next,&rdquo; you agree to our{" "}
                        <a href="/terms" target="_blank">
                            Terms
                        </a>{" "}
                        and{" "}
                        <a href="/privacy" target="_blank">
                            Privacy Policy
                        </a>
                    </p>
                    <p>
                        WorkStep is a third party working with {company.name} to help them
                        understand what is important to you, their employees.
                    </p>
                </footer>
            </div>
        );
    }
}

export default connect(mapStateToProps, { authWorkforceSignUp }, ownPropsPriority)(SurveySignUp);
